var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"sm":"12"}},[_c('CedisTable',{attrs:{"items":_vm.cedis,"hover":"","striped":"","border":"","small":"","fixed":"","caption":"CEDIS"},on:{"refresh":_vm.refreshItems}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }